import instance from 'utils/axiosConfig';

/**
 * 부서 목록 조회 API
 * @param {Object} [params] - 쿼리 파라미터
 * @returns {Promise} API 응답 - 부서 목록
 */
export const getDepartments = async () => {
    try {
        const response = await instance.get('/api/v1/auth/department');
        return response.data;
    } catch (error) {
        throw error;
    }
};
